import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";
import ImageWithFallback from "@/components/ImageWithFallback";
import EnquiryDialog from "@/components/EnquiryDialog";

export default function ProductCard({ product }) {
  return (
    <div data-testid={`product-card-${product.slug}`} className="biosyn-card overflow-hidden flex flex-col group">
      <Link to={`/products/${product.slug}`} className="block relative overflow-hidden" style={{ background: "#F5FAFC" }}>
        <div className="aspect-[4/3] flex items-center justify-center p-4">
          <ImageWithFallback
            src={product.image}
            alt={`${product.name} — ${product.category_name}`}
            className="max-h-full max-w-full object-contain transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        {product.featured && (
          <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full text-white" style={{ background: "#3FAE35" }}>
            Featured
          </span>
        )}
      </Link>

      <div className="p-5 flex flex-col flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-wider mb-1.5" style={{ color: "#087FBF" }}>
          {product.category_name}
        </p>
        <h3 className="font-heading text-lg font-bold leading-snug" style={{ color: "#063B63" }}>
          <Link to={`/products/${product.slug}`}>{product.name}</Link>
        </h3>
        {product.tagline && (
          <p className="mt-1 text-xs font-semibold" style={{ color: "#16B8D4" }}>{product.tagline}</p>
        )}
        <p className="mt-2 text-sm leading-relaxed line-clamp-2" style={{ color: "#4A6B82" }}>
          {product.short_description}
        </p>

        {product.presentation && (
          <div className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold self-start px-2.5 py-1 rounded-lg" style={{ background: "#F5FAFC", color: "#17324D" }}>
            <Package className="w-3.5 h-3.5" /> {product.presentation}
          </div>
        )}

        <div className="mt-5 pt-4 border-t flex items-center gap-2" style={{ borderColor: "rgba(8,127,191,0.1)" }}>
          <Link
            to={`/products/${product.slug}`}
            data-testid={`view-details-${product.slug}`}
            className="btn-primary flex-1 !py-2.5 !px-3 text-sm"
          >
            View Details <ArrowRight className="w-4 h-4" />
          </Link>
          <EnquiryDialog
            productName={product.name}
            productId={product.id}
            source="PRODUCT_ENQUIRY"
            trigger={
              <button data-testid={`request-info-${product.slug}`} className="btn-outline-blue !py-2.5 !px-3 text-sm whitespace-nowrap">
                Request Info
              </button>
            }
          />
        </div>
      </div>
    </div>
  );
}
